import produce from 'immer';

export const Types = {
  PUT_TASK_REPROCESS_REQUEST: '@task/PUT_TASK_REPROCESS_REQUEST',
  PUT_TASK_REPROCESS_RESPONSE: '@task/PUT_TASK_REPROCESS_RESPONSE',
  GET_TASK_DETAILS_LAST_ERROR_REQUEST:
    '@task/GET_TASK_DETAILS_LAST_ERROR_REQUEST',
  GET_TASK_DETAILS_LAST_ERROR_RESPONSE:
    '@task/GET_TASK_DETAILS_LAST_ERROR_RESPONSE',
};

const INITIAL_STATE = {
  putReprocessarTask: {
    success: false,
    error: null,
    loading: false,
    data: {},
  },
  getUltimoErroTask: {
    success: false,
    error: null,
    loading: false,
    data: {},
  },
};

export default function task(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case Types.PUT_TASK_REPROCESS_REQUEST: {
        draft.putReprocessarTask.loading = true;
        break;
      }
      case Types.PUT_TASK_REPROCESS_RESPONSE: {
        draft.putReprocessarTask.loading = false;
        draft.putReprocessarTask.data = action.payload.response;
        draft.putReprocessarTask.success = action.payload.success;
        draft.putReprocessarTask.error = false;
        break;
      }

      case Types.GET_TASK_DETAILS_LAST_ERROR_REQUEST: {
        draft.getUltimoErroTask.loading = true;
        break;
      }
      case Types.GET_TASK_DETAILS_LAST_ERROR_RESPONSE: {
        draft.getUltimoErroTask.loading = false;
        draft.getUltimoErroTask.data = action.payload.response;
        draft.getUltimoErroTask.success = action.payload.success;
        draft.getUltimoErroTask.error = false;
        break;
      }
      default:
    }
  });
}

export const Creators = {
  putReprocessarTaskRequest: (taskId) => ({
    type: Types.PUT_TASK_REPROCESS_REQUEST,
    payload: { taskId },
  }),
  putReprocessarTaskResponse: (response, success) => ({
    type: Types.PUT_TASK_REPROCESS_RESPONSE,
    payload: { response, success },
  }),
  getUltimoErroTaskRequest: (taskId) => ({
    type: Types.GET_TASK_DETAILS_LAST_ERROR_REQUEST,
    payload: { taskId },
  }),
  getUltimoErroTaskResponse: (response, success) => ({
    type: Types.GET_TASK_DETAILS_LAST_ERROR_RESPONSE,
    payload: { response, success },
  }),
};
